/* 🤖 this file was generated by script */
export const wiconApprovePath = {
  name: 'approve_path',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 10a2 2 0 11-4 0 2 2 0 014 0zm0 0h3m0 0a1 1 0 112 0m-2 0a1 1 0 102 0m0 0h3m0 0a1 1 0 112 0 1 1 0 01-2 0z"/></svg>`,
};
